module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/attachmentpoints/attachmentpoints-groupbinding/attachmentpoints-groupbinding.component.css
// module id = ./src/app/attachmentpoints/attachmentpoints-groupbinding/attachmentpoints-groupbinding.component.css
// module chunks = main